module.exports = __webpack_public_path__ + "static/media/icon-wechat.35fc339b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-wechat.svg
// module id = 401
// module chunks = 1